module.exports = __webpack_public_path__ + "assets/static/png/visa_verified.7744ef1a1e748364084129582302c572.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/frameFooter/images/visa_verified.png
 ** module id = 483
 ** module chunks = 1
 **/